import { Modal, Button, InputGroup, Form } from 'react-bootstrap'
import { useCallback, useState } from 'react'
import Cropper from 'react-easy-crop'
import getCroppedImg from './CropImage'
import { dataURLtoFile } from '../../../helpers/helpers'
import { useLang } from '../../../language'

export const ModalCropImage = ({ show, handleClose, height, setInputFile, escalas, handleSubirImagen, tipo }:any) => {
    
    const Lang = useLang()

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [rotation, setRotation] = useState(0)
    const [zoom, setZoom] = useState<any>(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    // const [croppedImage, setCroppedImage] = useState(null)
    const [escala, setEscala] = useState(escalas[0])

    const onCropComplete = useCallback((croppedArea:any, croppedAreaPixels:any) => {
        // console.log(croppedArea, croppedAreaPixels)
        setCroppedAreaPixels(croppedAreaPixels)
    }, [])

    const showCroppedImage = useCallback(async () => {

        try {

            if (show.payload) {
                const img = URL.createObjectURL(show.payload)
                const croppedImage = await getCroppedImg(
                    img,
                    croppedAreaPixels,
                    rotation
                )

                // setCroppedImage(croppedImage)

                // let file = new File([croppedImage], "img.png",{type:"image/png", lastModified:new Date().getTime()});
                // let container = new DataTransfer();
                // container.items.add(file);

                let file = dataURLtoFile(croppedImage, "img.png")

                // inputFileRef.current.files = container.files

                setInputFile([file])
                if(handleSubirImagen){
                    handleSubirImagen(tipo, file)
                }
                handleClose()
            }


        } catch (e) {
            console.error(e)
        }
    }, [croppedAreaPixels, rotation])

    const showCroppedImageDefault = async () => {
        
        if (show.payload) {
                
            setInputFile([show.payload])
            if(handleSubirImagen){
                handleSubirImagen(tipo, show.payload)
            }
            handleClose()
        }
    }

    return (
        <Modal show={show.value} onHide={handleClose}>
            <Modal.Header closeButton className='border-0 pt-4'>
                <Modal.Title className='h5'>{Lang('RECORTAR_IMAGEN')}</Modal.Title>

            </Modal.Header>
            <Modal.Body className='d-flex flex-column' style={{ 'height': height }}>
                {
                    escalas.length > 1 &&
                    <InputGroup className="mb-3">
                        {
                            escalas.map((item:any) => (
                                <Button variant='outline-secondary'
                                    onClick={() => setEscala(item)}
                                    className={JSON.stringify(item) === JSON.stringify(escala) ? 'active' : ''}
                                >
                                    {item.label}
                                </Button>
                            ))
                        }
                    </InputGroup>
                }

                <div className="position-relative flex-grow-1">
                    {
                        show.payload && <Cropper
                            image={URL.createObjectURL(show.payload)}
                            crop={crop}
                            zoom={zoom}
                            aspect={escala.x / escala.y}
                            onCropChange={setCrop}
                            onCropComplete={onCropComplete}
                            onZoomChange={setZoom}
                        />
                    }
                </div>
                {
                    <div className='mt-3'>
                        <Form.Label>
                            Range
                        </Form.Label>
                        <Form.Range 
                            value={zoom}
                            min={1}
                            max={3}
                            step={0.1}
                            aria-labelledby="Zoom"
                            onChange={(e) => setZoom(e.target.value)}
                        />
                    </div>
                }

            </Modal.Body>
            <Modal.Footer className='border-0'>
                <Button variant="default" onClick={showCroppedImageDefault}>
                    {Lang('MANTENER_ORIGINAL')}
                </Button>
                <Button variant="primary" onClick={showCroppedImage}>
                    {Lang('RECORTAR_IMAGEN')}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}